import React, { useContext } from 'react';
import logoRN from '../assets/images/logo-dibox-rn.png';
import { ConfigContext } from '../context/config.context';

const Header = () => {

  const { config  } = useContext(ConfigContext);
  
  return (
   <div className="headerTop">
    <div className="navbar-header">
      <img alt="Dibox Platform" src={logoRN} className="logo-size" />
    </div>
    {config !== null ?
      config.dashboard.payment_pending ?
        <div className="alertPay">
          Su licencia esta por vencer <b>{config.dashboard.expire}</b>
        </div> 
      : null
    : null }
   </div>
  )
}

export default Header;